export default "__VITE_ASSET__DIU$zjfh__"